import React, { forwardRef } from "react";
import Profilepic from "../../assets/images/profilePic.jpg";
import BackgroundImg from "../../assets/images/ProfileDropdownBG.png";
import { logOut } from "../../features/auth/services/auth";
import StyledText from "../StyledComponents/StyledText";
import styled from "styled-components";
import { useTheme } from "../../middleware/ThemeContext";
import IconLogOut from "../../assets/icons/IconLogOut";
import IconSun from "../../assets/icons/IconSun";
import IconMoon from "../../assets/icons/IconMoon";
import { Button } from "../form/Button";
import EditIcon from "../../assets/icons/EditIcon";

const ProfileCon = styled.div`
  position: absolute;
  right: 0px;
  top: 42px;
  z-index: 9999;
  border-radius: 5px;
  box-shadow: 1px 1px 40px 0px #00000026;
  padding: 20px;
  background-position: top;
  background-size: contain;
  background-repeat: no-repeat;
`;

const ImgCont = styled.div`
  width: 95px;
  height: 95px;
  background-color: white;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 1px 1px 40px 0px #00000026;
`;

interface ProfileDropdown {
  user?: {
    accountType?: number;
    title?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    secondaryEmail?: string;
    isOwner?: boolean;
    companyId?: number;
    statusId?: number;
    company?: {
      id?: number;
      name?: string;
      companyEmail?: string;
      statusId?: number;
    };
    signedUrl?: string;
  };
}

const ProfileDropdown = forwardRef<HTMLDivElement, ProfileDropdown>(
  (props, ref) => {
    const { theme, toggleTheme } = useTheme();
    const user = props.user;
    return (
      <ProfileCon
        ref={ref}
        style={{
          backgroundColor: theme.colors.topBarsColorBG,
          backgroundImage: `url(${BackgroundImg})`,
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "top",
        }}
      >
        <div className="d-flex align-items-center justify-content-center mt-4 mb-4 position-relative">
          <ImgCont theme={theme} className="rounded-circle">
            <img
              className="rounded-circle"
              src={user?.signedUrl || Profilepic}
              style={{ width: "88px", height: "88px" }}
              alt="Profile"
            />
            {/* <div
              className="position-absolute rounded-circle d-flex align-items-center justify-content-center cursor-pointer"
              style={{
                backgroundColor: theme.CorporateTheme.colors.background,
                width: "32px",
                height: "32px",
                right: 0,
                bottom: 0,
              }}
            >
              <EditIcon color={theme.CreateFormTheme.colors.textSecondary} />
            </div> */}
          </ImgCont>
        </div>
        <StyledText
          className="text-center"
          fontSize="16px"
          fontWeight={600}
          textColor={theme.CorporateTheme.colors.primary}
        >
          {user?.title} {user?.firstName} {user?.lastName}
        </StyledText>
        <StyledText
          className="text-center mt-2 mb-3"
          fontSize="14px"
          fontWeight={400}
          textColor={theme.CreateFormTheme.colors.textSecondary}
        >
          {user?.email}
        </StyledText>
        <div
          className="p-2 rounded-pill mb-3 d-flex gap-2"
          style={{ backgroundColor: theme.CorporateTheme.colors.headerBG }}
        >
          <ButtonTheme
            theme={theme}
            $variant={theme.name === "light" ? "active" : "notActive"}
            onClick={() => { theme.name !== "light" && toggleTheme()}}
          >
            <IconSun />
            Light Theme
          </ButtonTheme>
          <ButtonTheme
            theme={theme}
            $variant={theme.name === "dark" ? "active" : "notActive"}
            onClick={() => { theme.name !== "dark" && toggleTheme()}}
          >
            <IconMoon />
            Dark Theme
          </ButtonTheme>
        </div>
        <Button
          $variant="add"
          width="100%"
          textPosition="start"
          onClick={logOut}
        >
          <IconLogOut />
          Sign out
        </Button>
      </ProfileCon>
    );
  }
);

ProfileDropdown.displayName = "ProfileDropdown";

const ButtonTheme = styled.button<{ $variant?: "active" | "notActive" }>`
  width: 120px;
  border: 0.78px solid
    ${({ theme }) => theme.CreateFormTheme.colors.inputBorders};
  padding: 6px 14px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;

  color: ${({ $variant = "active", theme }) =>
    $variant === "active"
      ? theme.CreateFormTheme.colors.background
      : theme.CreateFormTheme.colors.textSecondary};

  background-color: ${({ $variant = "active", theme }) =>
    $variant === "active"
      ? theme.CorporateTheme.colors.primary
      : theme.CorporateTheme.colors.background};

  &:hover {
    background-color: ${({ $variant = "active", theme }) =>
      $variant === "active"
        ? theme.CorporateTheme.colors.primary
        : theme.CorporateTheme.colors.background};
  }
`;

export default ProfileDropdown;
